// extracted by mini-css-extract-plugin
module.exports = {"backLink":"backLink_backLink_2T2kh7Q","icon":"backLink_icon_2cNt-Gc"};